import axios from "axios";

import { getApiSitePrefix } from "../functions/SiteDefaults";

const privileges = async (props) => {
  const apiSitePrefix = getApiSitePrefix();
  const privilegeList = [];

  const privilegeData = await axios.get(`${apiSitePrefix}/permissions/list`);
  privilegeData.data.forEach(scope => {
    privilegeList.push(scope.value);
  });
  props.callback(privilegeList.join(' '));
}
export default privileges;